///<reference path="../../../typings/lodash/lodash.d.ts"/>
///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="../../../typings/angular-ui-bootstrap/angular-ui-bootstrap.d.ts"/>
///<reference path="processEditor-module.ts"/>
///<reference path="processResource.ts"/>
///<reference path="process.ts"/>
///<reference path="connectionDrawingService.ts"/>
///<reference path="taskService.ts"/>
///<reference path="referencesService.ts"/>
///<reference path="graphValidationService.ts"/>
///<reference path="processDetailsController.ts"/>

module ProcessEditor {
    'use strict';
    import ModalService = angular.ui.bootstrap.IModalService;
    import ModalSettings = angular.ui.bootstrap.IModalSettings;

    export function getMaxNodeId(nodes: INode[]): number {
        var indexRegexp: RegExp = /.*[^\d](\d+)$/;
        var maxIndexForType: number =
            _.max(nodes.map((n: Node) => {
                var match = n.nodeId.match(indexRegexp);
                if (_.isEmpty(match)) {
                    return 0;
                }
                return parseInt(_.last(match));
            }));

        if (!_.isNumber(maxIndexForType) || maxIndexForType < 0) {
            maxIndexForType = 0;
        }

        return maxIndexForType;
    }

    export interface IScopeEditorScope extends ng.IScope {
        node: ScopeNode;
    }

    export interface IScopeConnectionEventHandler {
        addNewConnection(connectionKey: INodeConnectionKey);
        removeConnection(connectionKey: INodeConnectionKey);
        moveEndpoint(elementId: string, newPosition: Position);
        addDecisionCondition(conditionInfo: ConditionInfo);
        updateDecisionCondition(originalConditionInfo: ConditionInfo, newConditionInfo: ConditionInfo);
        removeDecisionCondition(conditionInfo: ConditionInfo);
    }

    export class ScopeEditorController implements IScopeConnectionEventHandler {
        public node: ScopeNode;
        protected maxNodeIndex: number;
        protected connectionDrawingService: ConnectionDrawingService;
        protected endpointsInitialized: boolean;

        static $inject = ["$scope", "$timeout", "ConnectionDrawingServiceFactory", "ReferencesService", "TaskService", "graphEditDisabled", "highlightExecutions", "PopoverService", "GraphValidationService"];
        constructor(protected $scope: IScopeEditorScope,
            protected $timeout: ng.ITimeoutService,
            protected connectionDrawingServiceFactory: ConnectionDrawingServiceFactory,
            public referencesService: ReferencesService,
            public taskService: TaskService,
            public graphEditDisabled: boolean,
            public highlightExecutions: boolean,
            public popoverService: PopoverService,
            public graphValidationService: GraphValidationService) {

            $scope.$on("show.graph.frends", () => {
                this.initializeGraph();
            });

            $timeout(() => this.initializeGraph());

            $scope.$on("resized.scope.frends", () => {
                if (this.connectionDrawingService) {
                    this.connectionDrawingService.redrawEverything();
                }
            });
        }

        protected initializeGraph(forceReset: boolean = false) {
            if (forceReset && this.endpointsInitialized) {
                this.connectionDrawingService.reset();
                this.connectionDrawingService.drawEndpoints(this.node.nodes, this.graphEditDisabled);
                this.connectionDrawingService.drawConnections(this.node.connections, this.node.nodes, this.graphEditDisabled, this.highlightExecutions);
                return;
            }
            
            if (this.endpointsInitialized) {
                return;
            }

            // this method may get called also on an already initialized graph, e.g. inside a foreach execution scope
            // -> do not create new drawing service instances, it would cause duplicate endpoints etc.
            if (!this.connectionDrawingService) {
                var res = _.some($("#" + this.node.nodeId).parents(), (parent) => {
                    return $(parent).css('display') == 'none';
                });

                if (res) {
                    return;
                }
                // draw the connections only after the endpoints have been rendered and initialized
                this.connectionDrawingService = this.connectionDrawingServiceFactory.getConnectionDrawingServiceInstanceFor(this.node.nodeId, this);

                // All instances of connectionDrawingService get saved in the process object, and used for graph validation
                this.graphValidationService.drawingServiceInstances.push(this.connectionDrawingService);
            }

            this.connectionDrawingService.drawEndpoints(this.node.nodes, this.graphEditDisabled);
            this.connectionDrawingService.drawConnections(this.node.connections, this.node.nodes, this.graphEditDisabled, this.highlightExecutions);
            this.endpointsInitialized = true;

            this.$scope.$emit("changed.endpoint.frends");

            if (!this.graphEditDisabled) {
                this.taskService.getAvailableTasks();
            }
            this.maxNodeIndex = getMaxNodeId(this.node.nodes);
        }

        private getConnectionFromKey(key: INodeConnectionKey): NodeConnection {
            return new NodeConnection({
                sourceEndpointId: key.sourceEndpointId,
                targetEndpointId: key.targetEndpointId
            });
        }

        public addNewConnection(connectionKey: INodeConnectionKey) {
            const connection = this.getConnectionFromKey(connectionKey);
            const indexOfConn = _.findIndex(this.node.connections, item => item.connectionId === connection.connectionId);
            if (indexOfConn === -1) {
                this.node.connections.push(connection);
            }
        }

        public removeConnection(connectionKey: INodeConnectionKey) {
            var conn = this.getConnectionFromKey(connectionKey);
            if (conn.targetEndpointId) {
                // only try to update list if target endpoint is defined (this is not an aborted connection)
                // do not use $scope.$apply, because the event is usually already called in an $digest loop
                var indexOfConn = _.findIndex(this.node.connections, item => item.connectionId === conn.connectionId);
                if (indexOfConn === -1) {
                    console.error("Could not find connection with ID '%s' to remove.", conn.connectionId);
                } else {
                    this.node.connections.splice(indexOfConn, 1);
                }
            }
        }

        public addDecisionCondition(conditionInfo: ConditionInfo) {
            let decisionNode = <DecisionNode>_.find(this.node.nodes, (node) =>
                node.nodeId === getNodeIdFromEndpointId(conditionInfo.sourceEndpointId)
            );

            const conditionAlreadyExists = getConditionFromDecisionNode(decisionNode, conditionInfo);
            if (!conditionAlreadyExists) {
                const isElseBranch = getEndpointTypeFromEndpointId(conditionInfo.sourceEndpointId) === EndpointType.else;
                const newCondition = new ConditionBranch({
                    conditionId: conditionInfo.id,
                    isElseBranch: isElseBranch,
                    name: isElseBranch ? "else" : "",
                    expression: "",
                    sourceEndpointId: conditionInfo.sourceEndpointId,
                    targetEndpointId: conditionInfo.targetEndpointId
                });
                this.$scope.$apply(() => {
                    // push value in scope apply, so the popover content is there when the popover shows
                    let nodeHash = new NodeHash(this.node.nodes);
                    decisionNode.conditionBranches.push(newCondition);
                    decisionNode.conditionBranches.sort((a, b) => this.sortByNodePosition(a, b, nodeHash));
                });
            }

            // recheck the else nodes, clearing out possible errors
            this.$timeout(() => {
                this.graphValidationService.checkDecisionNodeElseBranches();
            });
        }

        public updateDecisionCondition(originalConditionInfo: ConditionInfo, newConditionInfo: ConditionInfo) {
            var decisionNode = <DecisionNode>_.find(this.node.nodes, (node) =>
                node.nodeId === getNodeIdFromEndpointId(originalConditionInfo.sourceEndpointId)
            );

            var conditionToUpdate = getConditionFromDecisionNode(decisionNode, originalConditionInfo);
            if (conditionToUpdate) {
                conditionToUpdate.sourceEndpointId = newConditionInfo.sourceEndpointId;
                conditionToUpdate.targetEndpointId = newConditionInfo.targetEndpointId;
            }
        }

        private sortByNodePosition(a: ConditionBranch, b: ConditionBranch, nodes: NodeHash) {
            if (a.isElseBranch) {
                return 1;
            }
            if (b.isElseBranch) {
                return -1;
            }

            let aTargetElementPosition = nodes[getNodeIdFromEndpointId(a.targetEndpointId)].position.top;
            let bTargetElementPosition = nodes[getNodeIdFromEndpointId(b.targetEndpointId)].position.top;
            return aTargetElementPosition - bTargetElementPosition;
        }

        private sortDecisionBranchesIfTargetMoved(movedNode: Node) {
            let connectionsToMovedNode = _.filter(this.node.connections, c => getNodeIdFromEndpointId(c.targetEndpointId) === movedNode.nodeId);
            let nodeHash = new NodeHash(this.node.nodes);
            for (var conn of connectionsToMovedNode) {
                let sourceNode = nodeHash[getNodeIdFromEndpointId(conn.sourceEndpointId)];
                if (sourceNode instanceof DecisionNode) {
                    sourceNode.conditionBranches.sort((a, b) => this.sortByNodePosition(a, b, nodeHash));
                }
            }
        }

        public removeDecisionCondition(conditionInfo: ConditionInfo) {
            if (conditionInfo.sourceEndpointId && conditionInfo.targetEndpointId) {
                var decisionNode = <DecisionNode>_.find(this.node.nodes, (node) => {
                    return node.nodeId === getNodeIdFromEndpointId(conditionInfo.sourceEndpointId);
                });

                if (decisionNode) {
                    const branch = getConditionFromDecisionNode(decisionNode, conditionInfo);

                    if (branch) {
                        if (branch.isElseBranch) {
                            this.$timeout(() => {
                                this.graphValidationService.checkDecisionNodeElseBranches();
                            });
                        }
                        if (conditionInfo.overlay) {
                            this.popoverService.disablePopover(angular.element(conditionInfo.overlay.canvas));
                        }

                        decisionNode.conditionBranches = _.reject(decisionNode.conditionBranches, b => b === branch);
                    }
                }
            }
        }

        /**
         * Registers that an endpoint was moved, storing the new position
         */
        public moveEndpoint(elementId: string, newPosition: Position) {
            var node = _.find(this.node.nodes, (n: Node) => n.nodeId === elementId);
            if (!node) {
                console.error("Could not find endpoint with id " + elementId);
            } else {
                node.position = newPosition;
                this.sortDecisionBranchesIfTargetMoved(node);
                this.$scope.$emit("changed.endpoint.frends");
            }
        }

        private addNewNode(newNode: Node) {
            this.node.nodes.push(newNode);
            this.$timeout(() => {
                this.connectionDrawingService.drawEndpoints([newNode], this.graphEditDisabled);
                this.$scope.$emit("changed.endpoint.frends");

                let popoverAnchorSelector = newNode.nodeId;
                // for scope nodes, open the popover from the start node
                if (newNode instanceof ScopeNode) {
                    this.showScopeStartNodePopover(newNode);
                } else {
                    this.popoverService.openPopover(this.node.nodeId, popoverAnchorSelector);
                }
                this.graphValidationService.markProcessDirty();
            });
        }

        public addTask() {
            this.taskService.getAvailableTasks().then((tasks) => {
                let firstTask = null;

                if (!_.isEmpty(tasks)) {
                    firstTask = _.first(tasks);
                }

                var newNode = new TaskNode({
                    nodeId: this.getId("TaskNode"),
                    position: this.connectionDrawingService.getNewNodePosition(this.node.nodes),
                    name: "",
                    taskName: firstTask && firstTask.name,
                    taskUri: firstTask && firstTask.uri,
                    returnType: firstTask && firstTask.returnType,
                    parameters: firstTask && this.taskService.getTaskParameters(firstTask.arguments, []),
                    description: firstTask && firstTask.description,
                    packageName: firstTask && firstTask.packageName
                });

                this.addNewNode(newNode);
            });
        }

        public addForeachScope() {
            var newNode = new ForeachScopeNode({
                nodeId: this.getId("ForeachScopeNode"),
                name: "Foreach",
                position: this.connectionDrawingService.getNewNodePosition(this.node.nodes),
            });

            this.addNewNode(newNode);
        }

        public addVariable() {
            this.node.variables.push(new Variable("", "\"\""));
        }

        public addErrorScope() {
            if (this.node.errorHandler) {
                throw "Error handler already exists";
            }

            this.node.errorHandler = new ErrorScopeNode({
                name: FRENDS.Localizations.ErrorHandler,
                nodeId: this.node.nodeId + "_errorBlock", // do not use getId() as it would add the '_block_' to the ID, breaking the node name hierarchy
                position: new Position({ top: 0, left: 0 })
            });

            this.graphValidationService.markProcessDirty();

            // also show the scope variable popout
            // needs to be called separately because the error handler is not added with addNode()
            this.$timeout(() => {
                this.showScopeStartNodePopover(this.node.errorHandler);
            });
        }

        public isErrorScope() {
            return this.node.$type === "ErrorScopeNode";
        }

        public getId(nodeType: string): string {
            if (_.isUndefined(this.maxNodeIndex)) {
                this.maxNodeIndex = getMaxNodeId(this.node.nodes);
            }
            return this.node.nodeId + "_block_" + nodeType + ++this.maxNodeIndex;
        }

        public addReturn() {
            var newNode = new ReturnNode({
                nodeId: this.getId("ReturnNode"),
                position: this.connectionDrawingService.getNewNodePosition(this.node.nodes),
                returnExpression: "#result"
            });

            this.addNewNode(newNode);
        }

        public addThrowError() {
            var newNode = new ThrowErrorNode({
                nodeId: this.getId("ThrowErrorNode"),
                position: this.connectionDrawingService.getNewNodePosition(this.node.nodes),
                errorMessage: "\"\""
            });

            this.addNewNode(newNode);
        }

        public addDecisionNode() {
            var newNode = new DecisionNode({
                nodeId: this.getId("DecisionNode"),
                name: "",
                position: this.connectionDrawingService.getNewNodePosition(this.node.nodes)
            });

            this.addNewNode(newNode);
        }

        public removeNode(node: Node) {
            var indexOfNode = this.node.nodes.indexOf(node);
            this.node.nodes.splice(indexOfNode, 1);

            this.connectionDrawingService.deleteEndpointElement(node.nodeId);
            this.removeConnectionDrawingServiceInstanceForScope(node.nodeId);
            this.graphValidationService.markProcessDirty();
        }

        public removeErrorHandler(errorScopeNodeId) {
            const taskNodeErrorBlockMatch = /(.*)_taskErrorBlock/.exec(errorScopeNodeId);
            let nodeErrorHandlerIsAttachedTo: INodeWithErrorHandler = this.node;
            if (taskNodeErrorBlockMatch) {
                const taskNodeId = taskNodeErrorBlockMatch[1];
                const matchingNodes = <TaskNode[]>this.node.nodes.filter(n => n.nodeId === taskNodeId && n instanceof TaskNode);
                if (_.isEmpty(matchingNodes)) {
                    throw `Could not find task node ${taskNodeId} to remove error handler from`;
                }
                nodeErrorHandlerIsAttachedTo = matchingNodes[0];
                // we also have to hide the error popover -> just hide everything inside this scope
                this.popoverService.hidePopovers(this.node.nodeId);
            }
            this.removeConnectionDrawingServiceInstanceForScope(errorScopeNodeId);
            this.popoverService.hidePopovers(errorScopeNodeId);
            nodeErrorHandlerIsAttachedTo.errorHandler = null;
            this.graphValidationService.markProcessDirty();
        }

        public addTaskErrorHandler(node: Node) {
            if (!(node instanceof TaskNode)) {
                throw "Can only add error handler task nodes, not to node " + node;
            }
            var taskNode = <TaskNode>node;
            taskNode.errorHandler = new ErrorScopeNode({
                name: FRENDS.Localizations.ErrorHandler,
                nodeId: taskNode.nodeId + "_taskErrorBlock", // do not use getId() as it would add the '_block_' to the ID, breaking the node name hierarchy
                position: new Position({ top: 0, left: 0 })
            });

            setTimeout(() => {
                this.popoverService.openPopover(this.node.nodeId, `#${taskNode.nodeId}_taskErrorHandler_anchor`);
            }, 0);
        }

        public updateConditionLabel(decisionNodeId: string, condition: ConditionBranch) {
            this.connectionDrawingService.updateLabels(decisionNodeId, condition);
        }

        public openNodePopoverIfNotDisabled(node: Node) {
            let executionData = node && (<INodeWithExecutionData>(<any>node)).executionData;

            if (!this.highlightExecutions || executionData) {
                // no execution data or the state is not disabled -> show
                this.popoverService.openPopover(this.node.nodeId, node.nodeId);
            }
        }
        public openPopover(elementSelector: string) {
            this.popoverService.openPopover(this.node.nodeId, elementSelector);
        }

        private removeConnectionDrawingServiceInstanceForScope(nodeId: string) {
            // When a scope is being removed (foreach or errorhandler), remove its respective drawing service instance.
            // Filters using instanceOf() because if a parent scope is removed (i.e foreach that has an error handler),
            // the child scope's instance should also be removed.
            this.graphValidationService.drawingServiceInstances = _.filter(this.graphValidationService.drawingServiceInstances, (drawingService) => {

                return drawingService.scopeId && drawingService.scopeId.indexOf(nodeId) === -1;
            });
        }

        private showScopeStartNodePopover(scopeNode: ScopeNode) {
            const startNode = _.find(scopeNode.nodes, n => n instanceof StartNode);
            if (!startNode) {
                console.error(`Scope ${scopeNode.nodeId} does not have a start node. Cannot show variable popover.`);
            } else {
                this.popoverService.openPopover(this.node.nodeId, startNode.nodeId);
            }
        }
    }

    app.controller("ScopeEditorController", ScopeEditorController);

    export class RootScopeEditorController extends ScopeEditorController {
        public process: Process;
        public rootScope: boolean;

        public static $inject = ["$scope", "$timeout", "$uibModal", "ConnectionDrawingServiceFactory", "ReferencesService", "TaskService", "graphEditDisabled", "highlightExecutions", "PopoverService", "GraphValidationService"];
        constructor($scope: IScopeEditorScope,
            $timeout: ng.ITimeoutService,
            private $modal: ModalService,
            connectionDrawingServiceFactory: ConnectionDrawingServiceFactory,
            referencesService: ReferencesService, taskService: TaskService,
            graphEditDisabled: boolean,
            highlightExecutions: boolean,
            popoverService: PopoverService,
            graphValidationService: GraphValidationService) {
            super($scope, $timeout, connectionDrawingServiceFactory, referencesService, taskService, graphEditDisabled, highlightExecutions, popoverService, graphValidationService);
            this.rootScope = true;
        }

        public openTriggersModal() {
            if (!this.graphEditDisabled) {
                var options: ModalSettings = {
                    templateUrl: "triggersModal.htm",
                    windowClass: "process-editor-triggers-modal",
                    size: "lg",
                    backdrop: "static",
                    controller: "TriggersModalController as triggersModalCtrl",
                    resolve: {
                        process: () => { return this.process; }
                    }
                };

                var triggersModal = this.$modal.open(options);
                triggersModal.result.then((triggersModalResult: TriggersModalResult) => {
                    if (triggersModalResult.changesMade) {
                        this.graphValidationService.markProcessDirty();
                        this.process.triggers = triggersModalResult.updatedProcess.triggers;
                    }
                });
            }
        }

        public getTriggerIconClass(trigger: Trigger) {
            switch (trigger.$type) {
                case 'ScheduleTrigger': return 'fa-clock-o';
                case 'HttpTrigger': return 'fa-globe';
                case 'FileWatchTrigger': return 'fa-file-o';
                case 'ServiceBusTrigger': return 'fa-arrows-h';
                case 'QueueTrigger': return 'fa-arrows-h';
                default:
                    console.log("unknown trigger type: " + trigger.$type);
                    return '';
            }
        }
    }

    app.controller("RootScopeEditorController", RootScopeEditorController);

    export class ErrorScopeEditorController extends ScopeEditorController {
    }

    app.controller("ErrorScopeEditorController", ["$scope", "$timeout", "ConnectionDrawingServiceFactory", "ReferencesService", "TaskService", "graphEditDisabled", "highlightExecutions", "PopoverService", "GraphValidationService", ErrorScopeEditorController]);

    export class ForeachScopeEditorController extends ScopeEditorController {
        public selectedForeachNodeIndex: number;
        public containerNode: ForeachScopeNodeContainer;
        public noPrevious: boolean;
        public noNext: boolean;

        static $inject = ["$scope", "$timeout", "ConnectionDrawingServiceFactory", "ReferencesService", "TaskService", "graphEditDisabled", "highlightExecutions", "PopoverService", "GraphValidationService"]
        constructor($scope: IScopeEditorScope,
            $timeout: ng.ITimeoutService,
            connectionDrawingServiceFactory: ConnectionDrawingServiceFactory,
            referencesService: ReferencesService,
            taskService: TaskService,
            graphEditDisabled: boolean,
            highlightExecutions: boolean,
            popoverService: PopoverService,
            graphValidationService: GraphValidationService) {
            super($scope, $timeout, connectionDrawingServiceFactory, referencesService, taskService, graphEditDisabled, highlightExecutions, popoverService, graphValidationService);
            if (this.node instanceof ForeachScopeNodeContainer) {
                this.containerNode = <ForeachScopeNodeContainer>this.node;
                let forceConnectionReset = false;
                this.selectNode(0, forceConnectionReset);
            }
        }

        public selectNode(index: number, forceConnectionReset: boolean = true) {
            if (this.containerNode) {
                if (this.containerNode.foreachExecutionNodes.length === 0) {
                    return; // just return, nothing to see here
                }

                this.selectedForeachNodeIndex = index;
                this.node = this.containerNode.foreachExecutionNodes[this.selectedForeachNodeIndex];
                this.noPrevious = this.selectedForeachNodeIndex <= 0 || !this.hasExecutionData();
                this.noNext = this.containerNode.foreachExecutionNodes.length - 1 <= this.selectedForeachNodeIndex || !this.hasExecutionData();

                this.popoverService.hidePopovers(this.node.nodeId);
                this.$timeout(() => this.initializeGraph(forceConnectionReset));
            }
        }
        private hasExecutionData(): boolean {
            return !!(<any>this.node).executionData;
        }
    }

    app.controller("ForeachScopeEditorController", ForeachScopeEditorController);

    export interface IValidationScope extends ng.IScope {
        showValidationErrors: boolean;
    }
}
